import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export const useTargetMarketShate = () => {
  const {
    UserStore: { userModulesRoles },
    MSPlanStore: {
      isConceptLoading,
      istmsPlanDataDirectLoading,
      TMSsalesSummaryData: MSplanConceptSalesDetails,
      isSalesDetailsLoading,
      tabIndex,
      isTMSNotesDataLoading,
      tmsNotesData,
      // salesplanstatus,
      msPlanStatusCheck,
      salesPlanStatusCheck,
      planBtnLabel,
      setTabIndex,
      fetchMSPlanBulkUpdategfcs,
      isSalesPlanStatusLoading,
      handleGetConceptDetails,
    },
  } = useStore();

  const { state } = useLocation();
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get('search');

  useEffect(() => {
    if (searchValue) {
      handleGetConceptDetails(parseFloat(searchValue));
    }
    if (state && state.from === 'finish') {
      handleGetConceptDetails(state.gfc);
    }
     
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // get future 12 months date
  const getFutureMonths = () => {
    const arr: { label: string; dateString: string }[] = [];
    const dt = new Date();
    const startMonth = dt.getMonth();
    const startYear = dt.getFullYear();
    const monthShortHand = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    for (let i = 0; i < 15; i++) {
      const month = (startMonth + i) % 12;
      const year = startYear + Math.floor((startMonth + i) / 12);
      arr.push({
        label: `${monthShortHand[month]}-${year}`,
        dateString: `${year}-${month >= 9 ? month + 1 : `0${month + 1}`}-01`,
      });
    }

    return arr;
  };
  const tmsPlanningMonth: { label: string; dateString: string }[] = getFutureMonths();

  const getSalesSummaryVal = (
    // summaryData: salesSummaryInterface[],
    cot: string,
    type: string,
    cat: string
  ) => {
    if (isSalesDetailsLoading) return undefined;

    // Handle cases where data might be undefined or empty
    if (!MSplanConceptSalesDetails || MSplanConceptSalesDetails.length === 0) {
      return 'NA';
    }

    const val = MSplanConceptSalesDetails.find(
      item => item.COT.toLowerCase() === cot.toLowerCase()
    );
    if (!val) return 'NA';

    switch (type) {
      case 'YTD':
        if (cat === 'direct') {
          if (val.YearToDateDirectShare !== null) {
            if (val.YearToDateDirectShare === 0) return val.YearToDateDirectShare;
            return val.YearToDateDirectShare + '%';
          } else {
            return 'NA';
          }
        } else if (cat === 'indirect') {
          if (val.YearToDateIndirectShare !== null) {
            if (val.YearToDateIndirectShare === 0) return val.YearToDateIndirectShare;
            return val.YearToDateIndirectShare + '%';
          } else {
            return 'NA';
          }
        }
        break;

      case '3MA':
        if (cat === 'direct') {
          if (val.LastThreeMonthDirectShare !== null) {
            if (val.LastThreeMonthDirectShare === 0) return val.LastThreeMonthDirectShare;
            return val.LastThreeMonthDirectShare + '%';
          } else {
            return 'NA';
          }
        } else if (cat === 'indirect') {
          if (val.LastThreeMonthIndirectShare !== null) {
            if (val.LastThreeMonthIndirectShare === 0) return val.LastThreeMonthIndirectShare;
            return val.LastThreeMonthIndirectShare + '%';
          } else {
            return 'NA';
          }
        }
        break;

      case 'PM':
        if (cat === 'direct') {
          if (val.LastMonthDirectShare !== null) {
            if (val.LastMonthDirectShare === 0) return val.LastMonthDirectShare;
            return val.LastMonthDirectShare + '%';
          } else {
            return 'NA';
          }
        } else if (cat === 'indirect') {
          if (val.LastMonthIndirectShare !== null) {
            if (val.LastMonthIndirectShare === 0) return val.LastMonthIndirectShare;
            return val.LastMonthIndirectShare + '%';
          } else {
            return 'NA';
          }
        }
        break;

      default:
        return 'NA';
    }
  };

  return {
    userModulesRoles,
    tmsPlanningMonth,
    tabIndex,
    setTabIndex,
    getSalesSummaryVal,
    isSalesDetailsLoading,
    MSplanConceptSalesDetails,
    istmsPlanDataDirectLoading,
    isConceptLoading,
    isTMSNotesDataLoading,
    tmsNotesData,
    // salesplanstatus,
    msPlanStatusCheck,
    salesPlanStatusCheck,
    planBtnLabel,
    isSalesPlanStatusLoading,
    fetchMSPlanBulkUpdategfcs,
    handleGetConceptDetails,
  };
};
